

export class UserTypeUpdateInput implements IUserTypeUpdateInput {
    /** The auto-generated id of the user type master */
    userTypeId!: number;
    /** The user type code with 255 character limit */
    userTypeCode!: string;
    /** The user type name with 255 character limit */
    userTypeName!: string;

    constructor(data?: IUserTypeUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypeId = _data["userTypeId"];
            this.userTypeCode = _data["userTypeCode"];
            this.userTypeName = _data["userTypeName"];
        }
    }

    static fromJS(data: any): UserTypeUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypeId"] = this.userTypeId;
        data["userTypeCode"] = this.userTypeCode;
        data["userTypeName"] = this.userTypeName;
        return data; 
    }
}

export interface IUserTypeUpdateInput {
    /** The auto-generated id of the user type master */
    userTypeId: number;
    /** The user type code with 255 character limit */
    userTypeCode: string;
    /** The user type name with 255 character limit */
    userTypeName: string;
}

